// 8.3.11 Video Moments UI (merged as `vm`).
const vm = {
 "label": "Una situación para ti",
 "play": "Reproducir",
 "pause": "Pausa",
 "replay": "Repetir",
 "showTranscript": "Ver transcripción",
 "hideTranscript": "Ocultar transcripción",
 "showMeaning": "Ver significado",
 "hideMeaning": "Ocultar significado",
 "whatWouldYouSay": "¿Qué dirías?",
 "placeholder": "Escribe tu respuesta en {lang}",
 "respond": "Responder",
 "natural": "Suena natural.",
 "better": "Una forma más natural podría ser:",
 "savePhrase": "Guardar frase",
 "saved": "Guardada",
 "usefulPhrases": "Frases útiles",
 "continueFriend": "Seguir en Fluent Friend",
 "openInterview": "Practicar una entrevista completa",
 "startMission": "Empezar la misión",
 "videoFailed": "No se pudo cargar el vídeo; aún puedes leer la escena y responder.",
 "respondFailed": "No se pudo enviar. Inténtalo de nuevo.",
 "retryVideo": "Reintentar vídeo",
 "recommendedLevel": "Nivel recomendado",
 "video": "Escena en vídeo",
 "titles": {"vm_cafe_es": "Pedir en una cafetería", "vm_hotel_fr": "Recepción del hotel", "vm_meet_de": "Conocer a alguien", "vm_interview_ar": "Inicio de una entrevista de trabajo", "vm_directions_sr": "Preguntar el camino", "vm_disagree_sr": "Un pequeño desacuerdo"},
 "roles": {"waitress": "camarera", "customer": "cliente", "receptionist": "recepcionista", "guest": "huésped", "interviewer": "entrevistador", "candidate": "candidato", "tourist": "turista", "passer-by": "transeúnte"}
};
export default vm;
